import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import EventDateFilter from '../Filters/EventDateFilter';
import FlexLeagueGameTypeFilter from '../Filters/FlexLeagueGameTypeFilter';

const FlexLeagueFilters = (props) => {
    const {
        search,
        handleFilterClick,
        state,
        filterInputs,
        searchTypes,
        closeModals,
        handleFilterSubmit,
        clearFilters,
        handleFilterUpdate,
        auth,
        filterType,
    } = props;

    const { filters = {} } = search;

    const commonFilterProps = {
        filters,
        filterInputs,
        handleFilterClick,
        filterModal: state.filterModal,
        closeModals,
        handleFilterSubmit,
        clearFilters,
        handleFilterUpdate,
    };
    const showTennisContent = !!auth?.feedPreferences?.showTennisContent;
    const showPickleballContent = !!auth?.feedPreferences?.showPickleballContent;

    useEffect(() => {
        handleFilterSubmit({
            sportTypes: {
                tennis: auth?.user ? showTennisContent : true,
                pickleball: auth?.user ? showPickleballContent : true,
            },
        });
    }, [filterType]);
    return (
        <React.Fragment>
            <EventDateFilter
                {...commonFilterProps}
                data-testid="search.flex-leagues.filter.date"
            />
            <FlexLeagueGameTypeFilter
                {...commonFilterProps}
                searchTypes={searchTypes}
                data-testid="search.flex-leagues.filter.game-type"
            />
        </React.Fragment>
    );
};

FlexLeagueFilters.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
    filterType: PropTypes.string.isRequired,
};

export default FlexLeagueFilters;
